export const PHOTOGRAPHCOLLECTION_CREATE_RESET = 'PHOTOGRAPHCOLLECTION_CREATE_RESET'
export const PHOTOGRAPHCOLLECTION_CREATE_SET_CREATED = 'PHOTOGRAPHCOLLECTION_CREATE_SET_CREATED'
export const PHOTOGRAPHCOLLECTION_CREATE_SET_ERROR = 'PHOTOGRAPHCOLLECTION_CREATE_SET_ERROR'
export const PHOTOGRAPHCOLLECTION_CREATE_SET_VIOLATIONS = 'PHOTOGRAPHCOLLECTION_CREATE_SET_VIOLATIONS'
export const PHOTOGRAPHCOLLECTION_CREATE_TOGGLE_LOADING = 'PHOTOGRAPHCOLLECTION_CREATE_TOGGLE_LOADING'
